import { render } from "./SalePriceProductDetails.vue?vue&type=template&id=0c3fe4ef&scoped=true&ts=true"
import script from "./SalePriceProductDetails.vue?vue&type=script&lang=ts"
export * from "./SalePriceProductDetails.vue?vue&type=script&lang=ts"

import "./SalePriceProductDetails.vue?vue&type=style&index=0&id=0c3fe4ef&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3fe4ef"]])

export default __exports__